
import api from './api';

const endpoint = '/api/vendas';

const VendasService = {
  getAll: async () => {
    const response = await api.get(endpoint);
    return response.data;
  },

  getAtivas: async () => {
    const response = await api.get(`${endpoint}/ativas`);
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`${endpoint}/${id}`);
    return response.data;
  },

  create: async (data) => {
    const response = await api.post(endpoint, data);
    return response.data;
  },

  update: async (id, data) => {
    return (await api.put(`${endpoint}/${id}`, data)).data;
  },

  remove: async (id) => {
    const response = await api.delete(`${endpoint}/${id}`);
    return response.data;
  },
};

export default VendasService;